<template>
  <button
    :class="$style['table-button']"
    @click="$emit('click')"
  >
    <slot name="content" />
    <span :class="$style['arrow-wrapper']">
      <slot name="arrow" />
    </span>
  </button>
</template>

<script>
export default {
  name: "DsTableButton"
};
</script>

<style lang="scss" module>
@import "../../scss/_variables.scss";
@import "../../scss/_mixins.scss";

.table-button {
  border: none;
  cursor: pointer;
  background-color: #fff;
  border-radius: 25px;
  text-transform: uppercase;
  color: $blue-color;
  padding: 13px 15px;
  display: flex;
  font-weight: 600;
  outline: none;
  font-size: 11px;
  // @include fluid-font(11px, true);
  line-height: 11px;
  .arrow-wrapper {
    svg {
      margin-left: 15px;
    }
  }
  a {
    &:hover {
      color: $blue-color;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-table-button.vue